import pluralize from 'pluralize';

angular.module('filters').filter('membershipRecurringPaymentFilter', ["$rootScope", "$filter", function($rootScope, $filter) {
  return function(membership) {
    var cost_repeat, paymentWithPeriod, startingDate, symbol;
    if (membership.cost_repeat > 0 && membership.plan_type === 'recurring') {
      symbol = $rootScope.gym.currency_symbol;
      cost_repeat = $filter('currency')(membership.cost_repeat, symbol);
      startingDate = $filter('stringToDate')(membership.recurring_payments_start_on);
      paymentWithPeriod = membership.charge_interval_number > 1 ? `${cost_repeat} every ${membership.charge_interval_number} ${membership.charge_interval_unit}` : `${cost_repeat}/${pluralize.singular(membership.charge_interval_unit)}`;
      return `${paymentWithPeriod} starting on ${startingDate}`;
    } else {
      return "No recurring payment";
    }
  };
}]);
